@if (group) {
  <div [formGroup]="group">
    <mat-form-field>
      <input
        matInput
        type="text"
        formControlName="value"
        placeholder="Input value"
        [attr.maxlength]="group.get('validators')?.value.maxLength || null" />
      @if (group.get('validators')?.value?.maxLength) {
        <mat-hint align="end">
          {{ group.get('value')?.value?.length || 0 }} / {{ group.get('validators')?.value.maxLength }}
        </mat-hint>
      }
      @if (showHint) {
        <mat-hint>{{ group.get('customFieldType')?.value | customFieldType }}</mat-hint>
      }
    </mat-form-field>
  </div>
}
